export default [
  {
    title: 'Partner',
    komicon: 'k-user-tick',
    children: [
      {
        title: 'Information',
        komicon: 'k-graph',
        route: 'information',
        resource: 'Partner - Information',
        action: 'manage',
      },
      {
        title: 'Verifikasi Partner',
        tagVariant: 'light-warning',
        route: 'verification-ktp',
        resource: 'Partner - Verifikasi Partner',
        action: 'manage',
        komicon: 'k-user-tick',
      },
      {
        title: 'Sektor Bisnis',
        komicon: 'k-home-1',
        route: 'business-category',
        resource: 'Partner - Sektor Bisnis',
        action: 'manage',
      },
      {
        title: 'Tipe Bisnis',
        komicon: 'k-chart-21',
        route: 'business-type',
        resource: 'Partner - Tipe Bisnis',
        action: 'manage',
      },
      {
        title: 'Organisasi',
        komicon: 'k-user-octagon',
        route: 'organization',
        resource: 'Partner - Organisasi',
        action: 'manage',
      },
      {
        title: 'Active Users',
        komicon: 'k-user-tick',
        route: 'active-users',
        resource: 'Partner - Active Users',
        action: 'manage',
      },
      {
        title: 'Drop-Off Analitik',
        customicon: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M22 22.75H5C2.93 22.75 1.25 21.07 1.25 19V2C1.25 1.59 1.59 1.25 2 1.25C2.41 1.25 2.75 1.59 2.75 2V19C2.75 20.24 3.76 21.25 5 21.25H22C22.41 21.25 22.75 21.59 22.75 22C22.75 22.41 22.41 22.75 22 22.75Z" fill="currentColor"/>
      <path d="M4.74982 5.99993C4.57982 5.99993 4.39982 6.05993 4.25982 6.17993C3.94982 6.44993 3.90982 6.91992 4.17982 7.23992L8.76982 12.5999C9.26982 13.1799 9.98982 13.5299 10.7498 13.5599C11.5098 13.5799 12.2598 13.2999 12.7998 12.7599L13.7498 11.8099C13.9998 11.5599 14.3298 11.4399 14.6798 11.4399C15.0298 11.4499 15.3498 11.6099 15.5798 11.8799L20.1698 17.2399C20.4398 17.5499 20.9098 17.5899 21.2298 17.3199C21.5398 17.0499 21.5798 16.5799 21.3098 16.2599L16.7198 10.8999C16.2198 10.3199 15.4998 9.96994 14.7398 9.93994C13.9798 9.91994 13.2298 10.1999 12.6898 10.7399L11.7498 11.6899C11.4998 11.9399 11.1698 12.0699 10.8198 12.0599C10.4698 12.0499 10.1498 11.8899 9.91982 11.6199L5.32982 6.25994C5.16982 6.08994 4.95982 5.99993 4.74982 5.99993Z" fill="currentColor"/>
      </svg>`,
        route: 'drop-off',
        resource: 'Partner - Drop Off',
        action: 'manage',
      },
    ],
  },
]
